import gql from 'graphql-tag';

import {
  CreateTemplateMutation,
  CreateTemplateMutationVariables,
  ListTemplatesQuery,
  ListTemplatesQueryVariables,
} from '../../API';
import { createTemplate as createTemplateMutaiton } from '../../graphql/mutations';
import { listTemplates } from '../../graphql/queries';

import { mutation, query } from './api';

const CREATE_TEMPLATE = gql(createTemplateMutaiton);
const LIST_TEMPLATES = gql(listTemplates);

export const TEMPLATE_FETCH_LIMIT = 100; // default fetch size is 100 but can be used to configure a different size or for testing the behavior of graphql query

export async function getTemplates(variables?: ListTemplatesQueryVariables) {
  const data = await query<ListTemplatesQueryVariables, ListTemplatesQuery>(LIST_TEMPLATES, {
    limit: TEMPLATE_FETCH_LIMIT,
    filter: {
      hidden: {
        ne: true,
      },
    },
    ...variables,
  });

  // TODO Remove once we implement sorting server side
  if (data.listTemplates?.nextToken) data.listTemplates.nextToken = null;

  if (data.listTemplates?.items) {
    data.listTemplates?.items.sort((firstItem, secondItem) => {
      const firstItemName = (firstItem?.name || '').toLowerCase();
      const secondItemName = (secondItem?.name || '').toLowerCase();

      return firstItemName.localeCompare(secondItemName);
    });
  }

  return data.listTemplates;
}

export async function createTemplate(variables?: CreateTemplateMutationVariables) {
  const data = await mutation<CreateTemplateMutationVariables, CreateTemplateMutation>(CREATE_TEMPLATE, variables);

  return data?.createTemplate;
}
